(function () {
  if (window.__wcalInit) { window.__wcalInit(); return; }

  var MONTHS = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
  var DAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  var DATE_RE = /(\d{1,2})[\/.](\d{1,2})(?:[\/.](\d{2,4}))?/;
  var RANGE_RE = /(\d{1,2}:\d{2})\s*[-–]\s*(\d{1,2}:\d{2})/;
  var TIME_RE = /(\d{1,2}:\d{2})/;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function monthIndex(d) { return d.getFullYear() * 12 + d.getMonth(); }
  function startOfToday() { var t = new Date(); t.setHours(0, 0, 0, 0); return t; }

  function parse(text, today) {
    var d = text.match(DATE_RE);
    if (!d) return null;
    var day = +d[1], month = +d[2], year = d[3] ? +d[3] : null;
    if (year && year < 100) year += 2000;
    if (!year) {
      year = today.getFullYear();
      if (new Date(year, month - 1, day) < today) year++;
    }
    var date = new Date(year, month - 1, day);
    if (isNaN(date) || date.getMonth() !== month - 1) return null;
    var r = text.match(RANGE_RE), t = r ? null : text.match(TIME_RE);
    return { date: date, start: r ? r[1] : (t ? t[1] : ''), end: r ? r[2] : '' };
  }

  function build(data, today) {
    var map = {}, list = [];
    data.forEach(function (w, wi) {
      if (!w.url) return;
      var own = [];
      function add(text, v) {
        var p = parse(text, today);
        if (!p) return;
        var key = wi + '|' + p.date.getTime() + '|' + p.start;
        var ev = map[key];
        if (!ev) {
          ev = map[key] = { w: w, name: w.name, date: p.date, start: p.start, end: p.end, url: w.url, price: w.price, options: [], available: false, picked: false };
          own.push(ev);
        }
        if (v) {
          // החלק שאחרי " / " בשם הווריאציה הוא סוג ההרשמה, למשל "משתתפת אחת" או "זוג משתתפות"
          var label = v.t.split(' / ').slice(1).join(' / ');
          if (label) ev.options.push({ label: label, price: v.p, a: v.a });
          // המועד מקושר לווריאציה הראשונה שלו שעדיין פנויה (בדרך כלל "משתתף/ת אחד/ת")
          if (!ev.picked || (!ev.available && v.a)) {
            ev.url = w.url + (w.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id;
            ev.price = v.p;
            ev.picked = true;
          }
          if (v.a) ev.available = true;
        } else {
          ev.available = !!w.available;
        }
      }
      (w.variants || []).forEach(function (v) { add(v.t, v); });
      (w.extra || '').split(/\r?\n/).forEach(function (line) { if (line.trim()) add(line, null); });
      // מספור שיעורים נעשה לפני הסתרת מועדים שעברו, כדי שהמספר יישאר נכון לאורך הקורס
      own.sort(function (a, b) { return a.date - b.date || a.start.localeCompare(b.start); });
      own.forEach(function (ev, i) {
        if (w.numbered) ev.name = w.name + ' · שיעור ' + (i + 1);
        if (ev.date >= today) list.push(ev);
      });
    });
    return list.sort(function (a, b) { return a.date - b.date || a.start.localeCompare(b.start); });
  }

  function init(root) {
    root.setAttribute('data-wcal-ready', '');
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-wcal-data]').textContent); } catch (e) {}
    var today = startOfToday();
    var events = build(data, today);
    var $ = function (s) { return root.querySelector(s); };
    var grid = $('[data-wcal-grid]'), title = $('[data-wcal-title]'), prev = $('[data-wcal-prev]'), next = $('[data-wcal-next]');
    var empty = $('[data-wcal-empty]'), legend = $('[data-wcal-legend]'), dialog = $('[data-wcal-dialog]');
    var content = dialog.querySelector('[data-wcal-d-content]');
    var mobile = window.matchMedia('(max-width: 749px)');

    var minMonth = monthIndex(today);
    var months = events.map(function (e) { return monthIndex(e.date); });
    var maxMonth = Math.max.apply(null, [minMonth].concat(months));
    var cur = months.indexOf(minMonth) > -1 || !months.length ? minMonth : months[0];

    var seen = [];
    events.forEach(function (e) {
      if (seen.indexOf(e.w) > -1) return;
      seen.push(e.w);
      var s = el('span'), i = el('i');
      i.style.setProperty('--c', e.w.color);
      s.append(i, e.w.name);
      legend.append(s);
    });

    // בידוד LTR כדי שטווח השעות לא יתהפך בעברית
    function timeText(ev) { return ev.end ? '⁦' + ev.start + '–' + ev.end + '⁩' : ev.start; }

    // פותח חלונית עם כל הסדנאות שנבחרו (בנייד: כל הסדנאות של היום שנלחץ)
    function open(evs) {
      if (!dialog.showModal) { window.location.href = evs[0].url; return; }
      dialog.style.setProperty('--c', evs[0].w.color);
      content.innerHTML = '';
      evs.forEach(function (ev) {
        var d = ev.date, box = el('div', 'wcal__ev');
        box.style.setProperty('--c', ev.w.color);
        box.append(el('h3', null, ev.name));
        box.append(el('p', null, 'יום ' + DAYS[d.getDay()] + ', ' + d.getDate() + ' ב' + MONTHS[d.getMonth()] + ' ' + d.getFullYear()));
        if (ev.start) box.append(el('p', null, 'בשעות ' + timeText(ev)));
        if (ev.options.length) {
          var prices = el('ul', 'wcal__prices');
          ev.options.forEach(function (o) {
            var li = el('li');
            li.append(el('span', null, o.label + (o.a || !ev.available ? '' : ' (אזל)')), el('b', null, o.price));
            prices.append(li);
          });
          box.append(prices);
        } else if (ev.price) {
          box.append(el('p', 'wcal__price', ev.price));
        }
        if (!ev.available) box.append(el('p', 'wcal__status', 'כל המקומות במועד הזה נתפסו'));
        var link = el('a', 'button button--primary', 'למידע נוסף');
        link.href = ev.url;
        box.append(link);
        content.append(box);
      });
      dialog.showModal();
    }

    function render() {
      var y = Math.floor(cur / 12), m = cur % 12;
      title.textContent = MONTHS[m] + ' ' + y;
      prev.disabled = cur <= minMonth;
      next.disabled = cur >= maxMonth;
      grid.innerHTML = '';

      var monthEvents = events.filter(function (e) { return monthIndex(e.date) === cur; });
      var firstDay = new Date(y, m, 1).getDay(), days = new Date(y, m + 1, 0).getDate();
      for (var b = 0; b < firstDay; b++) grid.append(el('div', 'wcal__cell wcal__cell--empty'));

      for (var d = 1; d <= days; d++) {
        var date = new Date(y, m, d), cell = el('div', 'wcal__cell');
        if (date < today) cell.classList.add('is-past');
        if (date.getTime() === today.getTime()) cell.classList.add('is-today');
        cell.append(el('span', 'wcal__num', d));
        var evs = monthEvents.filter(function (e) { return e.date.getDate() === d; });
        if (evs.length) {
          var dots = el('div', 'wcal__dots');
          cell.classList.add('has-events');
          cell.dataset.day = d;
          evs.forEach(function (ev) {
            var chip = el('button', 'wcal__chip' + (ev.available ? '' : ' is-full'));
            chip.type = 'button';
            chip.style.setProperty('--c', ev.w.color);
            if (ev.start) chip.append(el('span', 'wcal__chip-time', ev.start));
            chip.append(el('span', 'wcal__chip-name', ev.name));
            if (!ev.available) chip.append(el('span', 'wcal__badge', 'מלא'));
            chip.addEventListener('click', function () { open([ev]); });
            cell.append(chip);
            var dot = el('span', 'wcal__dot');
            dot.style.setProperty('--c', ev.w.color);
            dots.append(dot);
          });
          cell.append(dots);
          // בנייד מוצגות רק נקודות, ולחיצה על היום פותחת את החלונית
          (function (dayEvents) {
            cell.addEventListener('click', function () { if (mobile.matches) open(dayEvents); });
          })(evs);
        }
        grid.append(cell);
      }
      var trailing = (7 - ((firstDay + days) % 7)) % 7;
      for (var t = 0; t < trailing; t++) grid.append(el('div', 'wcal__cell wcal__cell--empty'));

      empty.innerHTML = '';
      empty.hidden = monthEvents.length > 0;
      if (!monthEvents.length) {
        empty.append(el('span', null, 'אין סדנאות מתוכננות בחודש הזה. '));
        var later = months.filter(function (mi) { return mi > cur; })[0];
        if (later != null) {
          var go = el('button', null, 'למועדים ב' + MONTHS[later % 12]);
          go.type = 'button';
          go.addEventListener('click', function () { cur = later; render(); });
          empty.append(go);
        }
      }
    }

    prev.addEventListener('click', function () { if (cur > minMonth) { cur--; render(); } });
    next.addEventListener('click', function () { if (cur < maxMonth) { cur++; render(); } });
    dialog.querySelector('[data-wcal-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    render();
  }

  window.__wcalInit = function () {
    document.querySelectorAll('[data-wcal]:not([data-wcal-ready])').forEach(init);
  };
  window.__wcalInit();
  document.addEventListener('shopify:section:load', window.__wcalInit);
})();